import { render, staticRenderFns } from "./ProgrammeEn.vue?vue&type=template&id=1efafd32&"
import script from "./ProgrammeEn.vue?vue&type=script&lang=js&"
export * from "./ProgrammeEn.vue?vue&type=script&lang=js&"
import style0 from "./ProgrammeEn.vue?vue&type=style&index=0&id=1efafd32&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports